import React from "react";

import { useDispatch, useSelector } from "react-redux";

import Heading from "@busbud/design-system-components/dist/Heading";
import Label from "@busbud/design-system-components/dist/Label";
import Stack from "@busbud/design-system-components/dist/Stack";
import type { ButtonProps } from "@busbud/horizon";
import { Button, ButtonIcon, IconXMark } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";
import { resetFilters } from "@app/modules/results/actions";
import { ClassFilters } from "@app/modules/results/components/filters/class-filters/class-filters";
import { DepartureTimeFilter } from "@app/modules/results/components/filters/departure-time";
import { OperatorFilter } from "@app/modules/results/components/filters/operator/operator";
import { PointOfInterestFilter } from "@app/modules/results/components/filters/point-of-interest";
import { PriceFilters } from "@app/modules/results/components/filters/price-filters/price-filters";
import { QuickFilters } from "@app/modules/results/components/filters/quick-filters/quick-filters.connect";
import { getLegCardsWithoutOutageCount } from "@app/modules/results/selectors/get-leg-cards-without-outage-count";
import { closeDrawer } from "@app/store/state/drawers";

import { useStyles } from "./results-filters.styles";

export const ResultsFilters = () => {
  const { translator } = useAppContext();
  const dispatch = useDispatch();
  const { classes } = useStyles();

  const leg_cards_count = useSelector(getLegCardsWithoutOutageCount);
  const button_appearance: ButtonProps["appearance"] =
    leg_cards_count === 0 ? "default" : "primary";

  const results_copy =
    leg_cards_count === 1
      ? translator.t("!results.filters.drawer.result-found")
      : translator.t("!results.filters.drawer.result-found.plural", {
          count: leg_cards_count
        });
  return (
    <Stack direction="column" width="100%" flexGrow={1}>
      <Stack
        className={classes.header}
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack spacing={2} alignItems="center">
          <ButtonIcon
            variant="text"
            size="lg"
            onClick={() => dispatch(closeDrawer())}
          >
            <IconXMark size="lg" />
          </ButtonIcon>
          <Heading size="sm">{translator.t("!results.filters.label")}</Heading>
        </Stack>
        <Button
          variant="text"
          appearance="default"
          size="md"
          onClick={() => dispatch(resetFilters())}
        >
          {translator.t("!results.filters.reset.all")}
        </Button>
      </Stack>

      <Stack direction="column" className={classes.filtersContainer}>
        <QuickFilters />
        <ClassFilters />
        <PriceFilters />
        <DepartureTimeFilter />
        <OperatorFilter />
        <PointOfInterestFilter point_of_interest_type="origin" />
        <PointOfInterestFilter point_of_interest_type="destination" />
      </Stack>

      <Stack spacing={2} direction="column" className={classes.footer}>
        <Stack direction="column" spacing={0.25}>
          <Label size="lg" fontWeight="bold">
            {results_copy}
          </Label>
          {leg_cards_count === 0 && (
            <Label size="sm" color="text.tertiary.opaque">
              {translator.t(
                "!results.alert.no-inventory.over-filtered.sub-header"
              )}
            </Label>
          )}
        </Stack>
        <Button
          size="xl"
          className="w-full"
          appearance={button_appearance}
          onClick={() => dispatch(closeDrawer())}
        >
          {translator.t("!results.filters.drawer.done")}
        </Button>
      </Stack>
    </Stack>
  );
};
